import { NgModule } from '@angular/core';
import { ExternalServiceService } from './external-service.service';
import { ExternalServiceResourceModule } from "../resources/external-service-resource/external-service-resource.module";

@NgModule({
    imports: [
        ExternalServiceResourceModule,
    ],
    providers: [
        ExternalServiceService,
    ],
})
export class ExternalServiceModule {}
